export const faqs = [
  {
    question: "How will I receive the material?",
    answer: "Immediately after your payment, you'll receive instructions by email to access the complete digital system. The six volumes and five bonuses are delivered digitally.",
  },
  {
    question: "Is Ortho Case Command Center™ a course?",
    answer: "No. It's a visual case-planning system. Instead of sitting through hours of video, you'll receive structured planning tools, worksheets, visual maps, matrices, checklists and protocols designed to help you organize your thinking.",
  },
  {
    question: "Do I need to be an orthodontic specialist?",
    answer: "The system is designed for dental professionals who already have relevant orthodontic knowledge and want a more structured way to organize case planning. It is not a replacement for professional education, diagnosis or clinical judgment.",
  },
  {
    question: "Can I use the Command Center more than once?",
    answer: "Yes. The system is designed to be reusable. You can print, duplicate and reuse the planning templates for different educational or professional case-planning situations.",
  },
  {
    question: "Is this a one-time payment?",
    answer: "Yes. The launch price is $27 USD, with no monthly subscription.",
  },
  {
    question: "Do I get lifetime access?",
    answer: "Yes. Your purchase includes lifetime digital access to the system.",
  },
  {
    question: "Can I use it for complex cases?",
    answer: "The framework is specifically designed to help organize cases where there are multiple findings, objectives, priorities, constraints and sequencing considerations. It is a planning framework, not a clinical prescription.",
  },
  {
    question: "What if I don't like it?",
    answer: "You are protected by my 7-Day Guarantee. Explore the six volumes, use the planning tools and decide whether the system is right for you. If you decide it isn't, contact us within seven days for a full refund.",
  },
];
